import { useCallback, useEffect, useState } from "react";

import { OTP_RESEND_COOLDOWN } from "@/constant";

interface UseCooldownReturn {
  cooldown: number;
  isCooldownActive: boolean;
  startCooldown: () => void;
  executeWithCooldown: (action: () => Promise<void>) => Promise<void>;
}

const useCooldown = (duration: number = OTP_RESEND_COOLDOWN): UseCooldownReturn => {
  const [cooldown, setCooldown] = useState(0);

  const startCooldown = useCallback(() => {
    setCooldown(duration);
  }, [duration]);

  const executeWithCooldown = useCallback(
    async (action: () => Promise<void>): Promise<void> => {
      if (cooldown > 0) return;

      await action();
      startCooldown();
    },
    [cooldown, startCooldown],
  );

  useEffect(() => {
    if (cooldown <= 0) return;

    const timer = setInterval(() => {
      setCooldown((previous) => Math.max(previous - 1, 0));
    }, 1000);

    return (): void => clearInterval(timer);
  }, [cooldown]);

  return {
    cooldown,
    isCooldownActive: cooldown > 0,
    startCooldown,
    executeWithCooldown,
  };
};

export default useCooldown;
